<template>
    <label class="floating-label relative flex flex-wrap" :class="mainClass ? mainClass : 'my-6'">
        <span
            class="absolute text-gray-400 flex items-center"
            :class="(isFocused ? 'text-xs' : 'pt-2 pb-1 px-1') + (focused && valid ? ' text-orange-400' : '') + validationClasses"
            :style="
        isFocused
          ? { top: '-10px', transition: 'all 200ms ease' }
          : { transition: 'all 200ms ease' }
      "
        >
            {{ label }}
            <span
                class="text-gray-400 text-xs ml-1"
            >{{ optional ? '(voliteľné)' : '' }}{{ required ? "*" : "" }}</span>
        </span>
        <input
            v-if="type !== 'textarea'"
            :value="value"
            :type="type"
            :name="name"
            :disabled="disabled"
            ref="input"
            :autocomplete="autocomplete ? 'on' : 'off'"
            :required="required"
            class="pt-2 pb-1 px-1 w-full"
            @keydown="makeValidation"
            @focusin="() => { onFocusIn(this.name, this.value); this.focused = true; }"
            @focusout="() => { onFocusOut(this.name, this.value); this.focused = false; }"
            @input="$emit('input', $event.target.value)"
            @keyup="$emit('keyup', $event)"
        />
        <textarea
            v-if="type === 'textarea'"
            :name="name"
            :disabled="disabled"
            :value="value"
            :autocomplete="autocomplete ? 'on' : 'off'"
            :required="required"
            ref="textarea"
            class="pt-2 pb-1 px-1 w-full"
            :class="areaClass"
            @keydown="makeValidation"
            @focusin="() => { onFocusIn(this.name, this.value); this.focused = true; }"
            @focusout="() => { onFocusOut(this.name, this.value); this.focused = false; }"
            @input="$emit('input', $event.target.value)"
            @keyup="$emit('keyup', $event)"
        ></textarea>
        <span
            class="relative block w-full"
            :class="disabled ? 'border-b border-dotted border-gray-600' : 'bg-gray-500'"
            :style="{ height: '1px' }"
        >
            <span
                class="w-0 absolute left-0 right-0 mx-auto transition"
                :class="(focused || !valid ? 'w-full ' : '') + (!valid ? 'bg-red-500' : 'bg-'+focusColor+'-300')"
                :style="{ height: '2px' }"
            ></span>
        </span>
    </label>
</template>

<script>
export default {
    name: "FloatingLabel",
    props: {
        required: {
            type: Boolean,
            default: false
        },
        autofocus: {
            type: Boolean,
            default: false
        },
        autocomplete: {
            type: Boolean,
            default: true
        },
        focusColor: {
            type: String,
            default: "orange"
        },
        value: {
            type: String | Number
        },
        label: {
            type: String,
            required: true
        },
        name: {
            default: "input",
            type: String
        },
        type: {
            default: "text",
            type: String
        },
        validation: {
            default: () => true,
            type: Function
        },
        onFocusIn: {
            default: () => null,
            type: Function
        },
        onFocusOut: {
            default: () => null,
            type: Function
        },
        areaClass: {
            default: "",
            type: String
        },
        mainClass: {
            default: "",
            type: String
        },
        optional: {
            default: false,
            type: Boolean
        },
        disabled: {
            default: false,
            type: Boolean
        }
    },
    data() {
        return {
            focused: false,
            validationClasses: "",
            valid: true
        };
    },
    mounted() {
        if (this.type === "textarea")
            this.$emit("input", this.$refs.textarea.value);
        else this.$emit("input", this.$refs.input.value);
    },
    computed: {
        isFocused() {
            return (
                this.focused ||
                (this.value !== null &&
                    this.value !== "" &&
                    typeof this.value !== "undefined")
            );
        }
    },
    methods: {
        makeValidation(e) {
            if (!this.validation(e.target.value)) {
                this.validationClasses = " text-red-500";
                this.valid = false;
            } else {
                this.validationClasses = "";
                this.valid = true;
            }
        }
    }
};
</script>
